<template>
  <!-- 我的项目 -->
  <div class="main">
    <!-- 标题行 -->
    <div class="titleRow">
      <div class="title">
        <el-divider direction="vertical"></el-divider>
        <span>我的项目</span>
      </div>
      <div class="options">
        <el-image :src="showType == 0 ? stripShow : stripHide" title="条状列表" @click="showType = 0"></el-image>
        <el-image :src="showType == 1 ? imgShow : imgHide" title="图状列表" @click="showType = 1"></el-image>
        <span @click="dialogProjectSort = true">排序<i class="el-icon-d-arrow-right"></i></span>
      </div>
    </div>
    <!-- 搜索行 -->
    <div class="searchRow">
      <el-input v-model="keyword" placeholder="请输入项目名称/项目编号" size="small" maxlength="20" clearable
        @keyup.enter.native="projectListFilter">
        <el-button slot="append" icon="el-icon-search" class="searchBtn" size="small" @click="projectListFilter"></el-button>
      </el-input>
    </div>

    <!-- 展示区 -->
    <div class="showArea">
      <!-- 条状列表 -->
      <div v-if="showType == 0" class="stripList">
        <div v-for="project in projectList" :key="project.prjId" class="stripItem"
          :class="{'stripItemClick': currentPrjId == project.prjId}" @click="projectClick(project)">
          <div class="stripName" :title="project.prjName">{{ project.prjName }}</div>
          <el-divider direction="vertical"></el-divider>
          <el-link type="primary" @click="enterProject(project)">进入<i class="el-icon-d-arrow-right"></i></el-link>
        </div>
      </div>
      <!-- 图状列表 -->
      <div v-if="showType == 1" class="imgList">
        <div v-for="project in projectList" :key="project.prjId" class="imgItem"
          :class="{'imgItemClick': currentPrjId == project.prjId}" @click="projectClick(project)">
          <el-avatar :src="project.img" class="userAvator" @error="errorHandler">
            <div class="avatortox">
              <el-image :src="projectImg" style="width: 100%"></el-image>
            </div>
          </el-avatar>
          <div class="imgRow">
            <span :title="project.prjName">{{ project.prjName }}</span>
            <el-tag type="primary" size="mini" @click="enterProject(project)">进入</el-tag>
          </div>
        </div>
      </div>
    </div>

    <!-- 项目排序弹框 -->
    <el-dialog v-dialogDrag :visible.sync="dialogProjectSort" title="项目排序" width="56%" top="11vh"
      class="dialogProjectSort" :close-on-click-modal="false" :close-on-press-escape="false" @open="sortProjects = [...myProjects]">
      <!-- 表格 -->
      <el-table height="540px" :row-class-name="tableRowClassName" highlight-current-row tooltip-effect="dark"
        :data="sortProjects" border>
        <el-table-column label="项目名称" prop="originalPrjName" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="项目编号" prop="prjCode" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="项目总负责人" prop="prjLeaderName" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-link v-if="scope.row.index > 0" type="primary" @click="moveSortProjects(scope.row.index, 1)">
              上移
            </el-link>
            <el-link v-if="scope.row.index < sortProjects.length-1" type="primary"
              @click="moveSortProjects(scope.row.index, 2)">
              下移
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogProjectSort = false">取 消</el-button>
        <el-button type="primary" size="small" @click="projectSortSure">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import workProjectBoardService from "@/CommonDP/service/workProjectBoard-service";
import { viewFile, getToken, storage } from "@/CommonDP/utils";
import keyCatalog from "@/CommonDP/service/folder-service";
export default {
  components: {},
  props: ["currentPrjId"],
  data() {
    return {
      stripHide: require("@/CommonDP/assets/workProjectBoard/stripHide.png"), // 条状隐藏
      stripShow: require("@/CommonDP/assets/workProjectBoard/stripShow.png"), // 条状展示
      imgHide: require("@/CommonDP/assets/workProjectBoard/imgHide.png"), // 图状隐藏
      imgShow: require("@/CommonDP/assets/workProjectBoard/imgShow.png"), // 图状展示
      projectImg: require("@/CommonDP/assets/workProjectBoard/projectImg.png"), // 项目图片
      showType: storage.get("workMyprojectsShowType") || 0, // 展示类型
      keyword: "", // 搜索内容
      myProjects: [], // 我的项目
      projectList: [], // 条状、图状项目列表

      sortProjects: [], // 排序的项目
      dialogProjectSort: false // 项目排序弹框
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },
  watch: {
    showType(val) {
      storage.set("workMyprojectsShowType", val);
    },
    keyword(val) {
      if (val === "") {
        this.projectListFilter();
      }
    }
  },
  mounted() {
  },
  methods: {
    setMyProjects(data) {
      this.myProjects = data;
      this.myProjects.forEach(item => {
        item.img = item.filePath ? viewFile(item.filePath, getToken()) : "";
        // 设置默认跳转项目条件
        if (this.currentPrjId) {
          if (item.prjId == this.currentPrjId) this.$emit("setCurrentProject", item);
        }
      });
      this.projectList = this.myProjects;
    },
    errorHandler() {
      return true;
    },
    // 把每一行的索引放进row
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },

    // 获得我的项目
    async getMyProjects() {
      const res = await workProjectBoardService.getMyProjects(this.enterpriseId);
      this.myProjects = res.data;
      this.myProjects.forEach(item => {
        item.img = item.filePath ? viewFile(item.filePath, getToken()) : "";
      });
    },
    // 项目点击
    projectClick(project) {
      this.$emit("setCurrentProject", project);
    },
    // 条状、图状项目列表筛选
    projectListFilter() {
      if (this.keyword) {
        this.projectList = this.myProjects.filter(item => {
          return item.prjName.indexOf(this.keyword) != -1;
        });
      } else {
        this.projectList = this.myProjects;
      }
    },
    // 进入项目
    async enterProject(project) {
      // 在进项目前 调用下接口
      const res = await keyCatalog.checkCatalogIsInit({ prjId: project.prjId });
      this.$store.dispatch("setCatalogToken", res.data ? "1" : "0");
      this.$store.dispatch("updatePrj", project);
      this.$router.push("/project");
    },

    // 项目排序,上移1  下移2
    moveSortProjects(index, moveType) {
      if (moveType == 1) {
        const arr = this.sortProjects;
        arr.splice(index - 1, 1, ...arr.splice(index, 1, arr[index - 1]));
      }
      if (moveType == 2) {
        const arr = this.sortProjects;
        arr.splice(index, 1, ...arr.splice(index + 1, 1, arr[index]));
      }
    },
    // 项目排序确定
    async projectSortSure() {
      const list = this.sortProjects.map(item => item.prjId);
      const params = {
        enterpriseId: this.enterpriseId,
        prjOrderList: list
      };
      await workProjectBoardService.moveSortProjects(params);
      await this.getMyProjects();
      this.projectList = this.myProjects;
      this.keyword = "";
      this.dialogProjectSort = false;
      this.$message.success("移动成功");
    }
  }
};
</script>

<style lang='scss' scoped>
.main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .titleRow {
    width: 100%;
    border-bottom: 1px solid #e5e8f1;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      display: flex;
      align-items: center;

      .el-divider {
        width: 3px;
        height: 15px;
        margin-left: 0;
        background: var(--theme-color);
      }

      span {
        font-weight: 700;
        font-size: 16px;
        color: var(--key-color);
      }
    }

    .options {
      display: flex;
      align-items: center;

      .el-image {
        width: 13px;
        height: 13px;
        margin-right: 15px;
        margin-top: 2px;
        cursor: pointer;
      }

      span {
        font-weight: 400;
        font-size: 14px;
        color: var(--common-color);
        cursor: pointer;
        display: flex;
        align-items: center;
      }
      span:hover {
        color: var(--theme-color);
      }
    }
  }

  .searchRow {
    width: 100%;

    .searchBtn {
      padding: 9px 13px !important;
      color: #ffffff;
    }
    .searchBtn:hover {
      color: #ffffff !important;
    }

    /deep/ .el-input-group__append {
      text-align: center;
      background: var(--theme-color);
    }
    /deep/ .el-input-group__append:hover {
      opacity: 0.8;
    }
  }

  .showArea {
    width: 100%;
    height: 1px;
    flex-grow: 1;

    .stripList {
      width: 100%;
      height: 100%;
      padding: 0 var(--big-space);
      overflow-y: hidden;
    }
    .stripList:hover {
      overflow-y: overlay !important;
      overflow-y: auto;
    }

    .imgList {
      width: 100%;
      height: 100%;
      padding: 0 var(--big-space);
      overflow-y: hidden;
    }
    .imgList:hover {
      overflow-y: overlay !important;
      overflow-y: auto;
    }
  }
}

.stripItem {
  width: 100%;
  height: 40px;
  padding: 0 var(--middle-space);
  margin-bottom: var(--middle-space);
  background: #f5f5f5;
  border-radius: 5px;
  cursor: pointer;

  display: flex;
  align-items: center;
  color: var(--key-color);

  span {
    width: 42px;
    white-space: nowrap;
    overflow: hidden;
    font-size: 14px;
  }

  .el-divider {
    width: 1px;
    height: 14px;
    background: var(--key-color);
  }

  .stripName {
    width: calc(100% - 54px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
  }

  .el-link {
    white-space: nowrap;
  }
}
.stripItem:hover {
  background: #eef3fd;
}
.stripItemClick {
  background: #eef3fd;
  color: var(--theme-color);

  .el-divider {
    background: var(--theme-color);
  }
}

.imgItem {
  width: 100%;
  padding: var(--middle-space);
  background: #ffffff;
  border: 1px solid #e9effb;
  margin: 4px 0 var(--middle-space);
  cursor: pointer;

  .imgRow {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      width: 150px;
      font-weight: 400;
      font-size: 15px;
      color: var(--key-color);

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .el-tag {
      width: 42px;
      height: 25px;
      padding: 0;
      border: none;
      background: rgba(85, 132, 255, 0.1);
      color: var(--theme-color);
      font-size: 14px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .el-tag:hover {
      background: #e4ebfc;
    }
  }
  .userAvator {
    width: 100%;
    height: 114px;
    margin-bottom: var(--small-space);
    border-radius: 0px !important;
    background: #ffffff00 !important;
  }
  /deep/ .el-avatar > img {
    width: 100%;
    height: 100%;
    object-fit: contain !important;
  }
}
.imgItem:hover {
  box-shadow: 0px 0px 10px rgba(71, 119, 231, 0.3);
}
.imgItemClick {
  box-shadow: 0px 0px 10px rgba(71, 119, 231, 0.3);
}

.el-table {
  width: 100%;
  margin: 15px 0;

  .el-link {
    margin: 0 10px;
  }
}
</style>

<style lang='scss'>
.dialogProjectSort {
  .el-dialog {
    border-radius: 4px !important;
  }

  .el-dialog__header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .el-dialog__title {
      font-weight: 400;
      font-size: 18px;
      line-height: 25px;
      color: var(--key-color);
    }

    .el-dialog__headerbtn {
      position: relative;
      top: 0 !important;
      right: 0 !important;
    }
  }

  .el-dialog__body {
    padding: 15px 20px !important;
  }

  .el-dialog__footer {
    padding: 7px 15px 8px !important;
  }
}
</style>
